export default "__VITE_ASSET__5c00e022__"